import React, { useEffect, useState } from "react";
import Section from "../../components/Section";
import { pageTitle } from "../../helpers/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import axiosInstance from "../../utils/axiosInstance";
import { addAppointmentSlots, addHoliday, deleteAppointmentSlot, deleteHoliday, fetchDoctorProfile } from "../../constants/ApiConstants";
import { Link, useNavigate } from "react-router-dom";
import CommonMobileHeader from "../../components/Header/CommonMobileHeader";
import FullPageLoader from "../../components/FullPageLoader";
import DoctorDetailHeader from "../../components/DoctorDetailHeader";
import { FaChevronRight, FaTrash, FaX } from "react-icons/fa6";
import { primaryColor } from "../../constants/colors";
import { format4DigitTimeToAmOrPM } from "../../utils/utils";
import MyModal from "../../components/MyModal";
import SecondaryButton from "../../components/SecondaryButton";
import InputField from "../../components/InputField";
import TimeInput from "material-ui-time-picker";
import toast from "react-hot-toast";
import ListEmptyText from "../../components/ListEmptyText";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
export default function ManageHolidays() {
  pageTitle("Manage Holidays");

  const initialWeekDays = [
    { dayNumber: 1, dayName: "Monday", slots: [] },
    { dayNumber: 2, dayName: "Tuesday", slots: [] },
    { dayNumber: 3, dayName: "Wednesday", slots: [] },
    { dayNumber: 4, dayName: "Thursday", slots: [] },
    { dayNumber: 5, dayName: "Friday", slots: [] },
    { dayNumber: 6, dayName: "Saturday", slots: [] },
    { dayNumber: 7, dayName: "Sunday", slots: [] },
  ];
  const [loading, setLoading] = useState(false);
  const doctorId = useSelector((state) => state.appSlice.doctorData?.id);
  const [weekDays, setWeekDays] = useState(initialWeekDays);
  const [doctorDetail, setDoctorDetail] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [showDatePicker, setShowDatePicker] = useState();

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setShowDatePicker(false);
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    fetchDoctorDetail();
  }, []);

  const fetchDoctorDetail = () => {
    setLoading(true);
    axiosInstance
      .post(fetchDoctorProfile, {
        doctor_id: doctorId,
      })
      .then((res) => {
        setDoctorDetail(res.data.data);
        setWeekDays(weekDays.map((it) => ({ ...it, slots: res.data?.data.slots.filter((dt) => dt.weekday == it.dayNumber) })));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onTimeChoose = (t) => {
    setModalData({ ...modalData, time: t });
  };
  function formatTime(time) {
    const hours = time.getHours().toString().padStart(2, "0");
    const minutes = time.getMinutes().toString().padStart(2, "0");
    return `${hours}${minutes}`;
  }

  const handleSubmit = () => {
    setSubmitting(true);
    axiosInstance
      .post(addHoliday, {
        doctor_id: doctorId,
        date: `${selectedDate.getFullYear()}-${selectedDate.getMonth() + 1}-${selectedDate.getDate()}`,
      })
      .then((res) => {
        setModalData(null);
        setModalOpen(false);
        if (res.data?.status) {
          toast.success("Holiday added successfully.");
          fetchDoctorDetail();
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        console.log(err.toString());
        toast.error("Unable to save Holiday.");
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const handleDeleteHoliday = (holidayId) => {
    axiosInstance
      .post(deleteHoliday, {
        doctor_id: doctorId,
        holiday_id: holidayId,
      })
      .then((res) => {
        toast.success("Holiday deleted successfully.");
        fetchDoctorDetail();
      })
      .catch((err) => {
        console.log(err.toString());
        toast.error("Unable to delete Holiday.");
      })
      .finally(() => {});
  };
  function formatDate(inputDate) {
    const [year, month, day] = inputDate.split("-");
    const date = new Date(year, month - 1, day);
    const options = { day: "numeric", month: "long", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  const onDateClick = () => {
    setShowDatePicker(true);
  };

  return (
    <Wrapper>
      {loading ? (
        <FullPageLoader />
      ) : (
        <Section topMd={0} topLg={0} topXl={110} bottomMd={200} bottomLg={150} bottomXl={110}>
          <div className="content-wrapper d-flex flex-column px-3 gap-1 justify-content-center mx-auto">
            <CommonMobileHeader
              canBack
              title="Manage Holidays"
              trailing={
                <button type="button" onClick={() => setModalOpen(true)} className="bg-success-surface h-100">
                  Add
                </button>
              }
            />
            <div className="row">
              <div className="col-md-6">
                <div className="py-3 bg-white">
                  <strong className="text-dark fw-medium">Add your holidays here</strong>
                  <p className="text-grey2 fs-normal">On those days, Patients would not be able to book appointments for consultation.</p>
                </div>
              </div>
              <div className="col-md-6">
                {doctorDetail?.holidays?.length === 0 && <ListEmptyText text={"No Holidays found."} />}
                {doctorDetail?.holidays.length > 0 && (
                  <div className="d-flex flex-column gap-1">
                    {doctorDetail?.holidays.map((holiday) => (
                      <div key={holiday.id} className="bg-grey2 px-2 py-2 rounded d-flex justify-content-between align-items-center w-100 mb-2">
                        <strong className="fs-normal fw-normal text-grey2">{formatDate(holiday.date)}</strong>
                        <button type="button" className="bg-transparent" onClick={() => handleDeleteHoliday(holiday.id)}>
                          <FaTrash color={primaryColor} className="d-block" />
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
          <MyModal isOpen={modalOpen} modalTitle={"Add Holiday"} onClose={() => setModalOpen(false)}>
            <div className="d-flex flex-column gap-2 mt-3">
              <div className="bg-grey2 px-2 py-1 fs-normal text-center border rounded mb-3">
                <DatePicker locale="in" selected={selectedDate} onChange={handleDateChange} dateFormat="dd-MM-yyyy" />
              </div>
              <SecondaryButton title="Continue" onClick={handleSubmit} loading={submitting} />
            </div>
          </MyModal>
        </Section>
      )}
    </Wrapper>
  );
}
const Wrapper = styled.div``;
